module.exports = __webpack_public_path__ + "img/USA-Worst-2070 - 2099.0341d340.png";